var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.user
    ? _c("div", { staticClass: "content-container" }, [
        _c("img", {
          staticClass: "mb-4 rounded-circle",
          attrs: {
            src: _vm.computedSrc,
            alt: "user-profile-pict",
            width: "160px",
            height: "160px"
          }
        }),
        _vm._v(" "),
        _c("h2", { staticClass: "wrap-text" }, [
          _vm._v("\n    " + _vm._s(_vm.computedGreeting) + "\n  ")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "mb-5" }, [
          _vm._v(_vm._s(_vm.welcomeInfo.dailyLogin.message))
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "action-btn vs-btn close-welcome-modal-btn",
            attrs: { type: "button" },
            on: { click: _vm.closeModal }
          },
          [_vm._v("\n    Close\n  ")]
        )
      ])
    : _c("div", { staticClass: "p-6 text-center" }, [
        _vm._v("\n  Loading...\n")
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }